import React from 'react';
import { Facebook, Instagram, Youtube, Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-zinc-900 to-black border-t border-zinc-800">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <img 
                src="https://customer-assets.emergentagent.com/job_boss-shine-2026/artifacts/56v5wwxv_boss%20logo.jpg"
                alt="Boss Detailing Pro Logo"
                className="h-24 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Premium mobile car detailing in Sacramento & surrounding areas. We bring the shine to you!
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com/bossdetailingpros/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-zinc-800 hover:bg-orange-500 rounded-full flex items-center justify-center transition-colors duration-300 group"
              >
                <Instagram className="w-5 h-5 text-gray-400 group-hover:text-white" />
              </a>
              <a
                href="https://www.youtube.com/@bossdetailingpros"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-zinc-800 hover:bg-orange-500 rounded-full flex items-center justify-center transition-colors duration-300 group"
              >
                <Youtube className="w-5 h-5 text-gray-400 group-hover:text-white" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {[
                { name: 'Services', href: '#services' },
                { name: 'Packages', href: '#packages' },
                { name: 'Reviews', href: '#reviews' },
                { name: 'Portfolio', href: '#portfolio' },
                { name: 'Videos', href: '#videos' }
              ].map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-orange-500 transition-colors duration-300 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Services</h3>
            <ul className="space-y-2">
              {[
                'Interior Detailing',
                'Exterior Detailing',
                'Ceramic Coating',
                'Paint Protection',
                'Fleet Detailing',
                'Maintenance Packages'
              ].map((service) => (
                <li key={service}>
                  <span className="text-gray-400 text-sm">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-4">
              <li>
                <a
                  href="tel:9162993189"
                  className="flex items-start gap-3 text-gray-400 hover:text-orange-500 transition-colors duration-300 group"
                >
                  <Phone className="w-5 h-5 flex-shrink-0 mt-0.5 group-hover:scale-110 transition-transform" />
                  <span className="text-sm">(916) 299-3189</span>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-gray-400">
                  <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <span className="text-sm">Sacramento, CA & Surrounding Areas</span>
                </div>
              </li>
              <li>
                <div className="flex items-start gap-3 text-gray-400">
                  <Mail className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <span className="text-sm">Available 7 Days a Week</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-zinc-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {currentYear} Boss Detailing Pros LLC. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-gray-500 hover:text-orange-500 text-sm transition-colors duration-300">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-orange-500 text-sm transition-colors duration-300">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Floating CTA Button */}
      <a
        href="#quote"
        className="fixed bottom-8 right-8 bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-bold px-6 py-4 rounded-full shadow-2xl hover:shadow-orange-500/50 transform hover:scale-110 transition-all duration-300 z-40 flex items-center gap-2"
      >
        <Phone className="w-5 h-5" />
        <span className="hidden sm:inline">Book Now</span>
      </a>
    </footer>
  );
};

export default Footer;
